<div class="totals-container">
    <div class="total-card" *ngFor="let item of resultTotals; trackBy: trackByIndex">
        <div class="title">{{ item.alias }}</div>
        <div class="value">
            {{ item.quantity | number:'1.2-2' }} €
        </div>
    </div>
</div>